export default __webpack_public_path__ + "media/zurb/img/about/bryan/flickr-icon-b82d9b724aa9504fba33fd6f253dcf1f.svg";